import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Hero = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollToProducts = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const element = document.getElementById('products');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If we're on another page, navigate home first then scroll
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('products');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <section className="relative pt-24 pb-20 lg:pt-32 lg:pb-40 overflow-hidden px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Left Column: Content */}
          <div className="text-left order-2 lg:order-1">
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              <h1 className="text-5xl sm:text-6xl xl:text-7xl font-extrabold tracking-tight text-zinc-950 uppercase leading-[0.95] lg:max-w-xl">
                Kill Overwhelm.<br />
                <span className="text-zinc-400">
                  Bypass Paralysis.
                </span>
              </h1>
            </motion.div>
            
            <motion.p 
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="mt-8 text-lg sm:text-xl text-zinc-500 font-normal max-w-lg leading-relaxed"
            >
              Science-based productivity tools and Notion templates designed to help ADHD brains and modern creators move from chaos to clarity.
            </motion.p>
            
            <motion.div 
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 flex flex-col sm:flex-row gap-4 items-start"
            >
              <Link style={{
      color: 'rgb(255, 255, 255)'
    }} 
                to="/#products"
                onClick={handleScrollToProducts}
                className="w-full sm:w-auto px-10 py-4 bg-zinc-950 text-white rounded-md font-medium text-lg transition-all hover:bg-zinc-800 active:scale-[0.98] text-center"
              >Get ADHD Content Planner</Link>
              <Link 
                to="/#products"
                onClick={handleScrollToProducts}
                className="w-full sm:w-auto px-10 py-4 bg-white text-zinc-950 border border-zinc-200 rounded-md font-medium text-lg transition-all hover:border-zinc-400 hover:bg-zinc-50 active:scale-[0.98] text-center"
              >
                Browse All Products
              </Link>
            </motion.div>
          </div>

          {/* Right Column: Clean Image Placeholder */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="relative order-1 lg:order-2"
          >
            <div className="relative aspect-video w-full overflow-hidden rounded-2xl bg-zinc-50 border border-zinc-100 shadow-xl shadow-zinc-200/50">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/b8c61b7f3730bd89f93e4b383712de9d.jpeg" 
                alt="ADHD Content Planner Dashboard" 
                className="w-full h-full object-cover opacity-90 transition-opacity hover:opacity-100 duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/10 to-transparent pointer-events-none" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Hero;